import type { OutreachCallStatus } from "../../types/outreach";
import { httpClient } from "./httpClient";

export type CandidateData = {
    candidate: {
        id: string;
        firstName: string;
        callStatus: OutreachCallStatus;
        language: string;
    };
    legal: {
        privacyPolicies?: { url: string }[];
    };
    campaign: {
        companyName?: string;
        customerName: string;
        languages: string[];
    };
    actions: {
        canCancel: boolean;
        canReschedule: boolean;
        canChatInterview: boolean;
    };
};

export interface ApiError extends Error {
    status?: number;
}

export const fetchOutreachCandidateById = (candidateId: string) => async () => {
    const result = await httpClient.get<{ data: CandidateData }>(`/rest/outreach/candidates/${candidateId}`, {
        auth: false,
    });
    return result.data;
};

export const initiateOutreachChat = async (candidateId: string) => {
    const result = await httpClient.post<{ data: { token: string; dynamicVariables: Record<string, string> } }>(
        `/rest/outreach/candidates/${candidateId}/initiate-chat`,
        undefined,
        { auth: false },
    );
    return result.data;
};

export const cancelOutreachVoiceConversation = async (candidateId: string) => {
    const result = await httpClient.post<{ data: CandidateData }>(
        `/rest/outreach/candidates/${candidateId}/cancel`,
        undefined,
        { auth: false },
    );
    return result.data;
};
